import classNames from 'classnames';

import { LinkFragmentFragment } from '../../__generated__/graphql';
import { sanitizeHtml } from '../../utils/sanitzeHtml';
import { Paragraph, TextLink } from '../Text';

import style from './bread-crumbs.module.css';

interface BreadCrumbsProps {
  breadCrumbMenuItems: LinkFragmentFragment[];
  className?: string;
}

const BreadCrumbs = ({
  breadCrumbMenuItems,
  className,
}: BreadCrumbsProps) => {
  if (!breadCrumbMenuItems.length) {
    return null;
  }

  // We must use dangerouslySetInnerHTML here because the WP API returns HTML entities in the title
  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={style.container}>
        <ul className={style.breadCrumbs}>
          {breadCrumbMenuItems.map((menuItem, index) => {
            const isLast = index === breadCrumbMenuItems.length - 1;

            if (isLast) {
              return (
                <li key={menuItem.title}>
                  <Paragraph
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(menuItem.title ?? '') }}
                    fontColor="turquoise"
                    fontSize={12}
                  />
                </li>
              );
            }

            return (
              <li key={menuItem.title}>
                <TextLink
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(menuItem.title ?? '') }}
                  fontSize={12}
                  linkFragment={menuItem}
                  uppercase
                />

                &#8250;
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default BreadCrumbs;
